if (!customElements.get('amora-bundle-selector')) {
  customElements.define('amora-bundle-selector', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const data = this.querySelector('[data-bundle-data]');
      if (!data) { requestAnimationFrame(() => this.connectedCallback()); return; }
      this.variants = JSON.parse(data.textContent);
      this.labels = JSON.parse(this.querySelector('[data-bundle-labels]').textContent);
      this.initialized = true;
      this.variantId = Number(this.dataset.variant);
      this.count = 1;
      this.ids = [this.variantId];
      this.info = this.closest('product-info');
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:this.dataset.currency || 'USD'});
      this.details = this.querySelector('details');
      this.addEventListener('change', event => {
        if (event.target.matches('input[type=radio]')) {
          this.count = Number(event.target.value);
          this.ids = Array.from({length:this.count}, (_,i) => this.ids[i] || this.variantId);
          this.renderSelects();
        } else if (event.target.matches('[data-piece-option]')) { this.changeOption(Number(event.target.dataset.piece), Number(event.target.dataset.pieceOption), event.target.value); return; }
        this.update();
      });
      this.addEventListener('click', event => {
        const choice=event.target.closest('[data-piece-colour]');
        if(choice)this.changeOption(Number(choice.dataset.piece),0,choice.dataset.pieceColour);
      });
      if (typeof subscribe === 'function') this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, event => {
        if (event.data?.sectionId !== this.dataset.section || !event.data.variant) return;
        this.variantId = Number(event.data.variant.id);
        const previous = this.variants.find(v => Number(v.id) === this.variantId);
        if (previous) Object.assign(previous, event.data.variant);
        if (!this.details.open) this.ids = Array(this.count).fill(this.variantId);
        else this.ids[0] = this.variantId;
        this.renderSelects(); this.update();
      });
      this.renderSelects(); this.update();
      this.querySelector('fieldset').disabled = false;
      this.info?.querySelector('.amora-bundle-native-quantity')?.classList.add('amora-bundle-ready');
    }
    disconnectedCallback() { this.unsubscribe?.(); this.initialized = false; }
    getItems() {
      if (!this.ids?.length) return null;
      const groups = new Map();
      this.ids.forEach(id => groups.set(id, (groups.get(id) || 0) + 1));
      return [...groups].map(([id, quantity]) => ({id, quantity}));
    }
    colour(value) {
      const colours={'black':'#232323','champagne':'#c5a98d','dark blue':'#21334e','dark gray':'#646269','dark grey':'#646269','light pink':'#e7bfbb','silver gray':'#b4b3bb','silver grey':'#b4b3bb','white':'#f8f3ea','smoky pink':'#bc8e95'};
      return colours[value.toLowerCase()] || '#c5a98d';
    }
    changeOption(index, position, value) {
      const current=this.variants.find(v=>Number(v.id)===this.ids[index]);
      const options=[...current.options];options[position]=value;
      const next=this.variants.find(v=>v.available&&v.options.every((o,i)=>o===options[i]));
      if(!next)return;
      this.ids[index]=Number(next.id);this.renderSelects(index);this.update();
    }
    renderSelects(activeIndex) {
      this.details.hidden = this.count === 1;
      const container = this.querySelector('[data-bundle-variants]');
      const open=new Set(Array.from(container.querySelectorAll('details[open]')).map(e=>Number(e.dataset.pieceCard)));
      if(activeIndex!==undefined)open.add(activeIndex);
      container.replaceChildren();
      this.ids.forEach((id,index)=>{
        const variant=this.variants.find(v=>Number(v.id)===id);
        if(!variant)return;
        const card=document.createElement('details');card.className='amora-piece-card';card.dataset.pieceCard=index;card.open=open.has(index);
        const summary=document.createElement('summary');
        const dot=document.createElement('span');dot.className='amora-piece-dot';dot.style.background=this.colour(variant.options[0]);
        const info=document.createElement('span');
        const heading=document.createElement('strong');heading.textContent=`${this.labels.piece} ${index+1}`;
        const meta=document.createElement('small');meta.textContent=variant.options.join(' · ');
        info.append(heading,meta);
        const edit=document.createElement('span');edit.className='amora-piece-edit';edit.textContent=this.labels.edit;
        summary.append(dot,info,edit);card.append(summary);
        const body=document.createElement('div');body.className='amora-piece-body';
        const colourLabel=document.createElement('p');colourLabel.textContent=`${this.labels.colour} — ${variant.options[0]}`;body.append(colourLabel);
        const swatches=document.createElement('div');swatches.className='amora-piece-swatches';
        [...new Set(this.variants.map(v=>v.options[0]))].forEach(value=>{
          const options=[...variant.options];options[0]=value;
          const available=this.variants.some(v=>v.available&&v.options.every((o,i)=>o===options[i]));
          const button=document.createElement('button');button.type='button';button.dataset.piece=index;button.dataset.pieceColour=value;button.title=value;button.setAttribute('aria-label',`${this.labels.piece} ${index+1}: ${value}`);button.setAttribute('aria-pressed',String(value===variant.options[0]));button.style.setProperty('--piece-colour',this.colour(value));button.disabled=!available;swatches.append(button);
        });body.append(swatches);
        const row=document.createElement('div');row.className='amora-piece-options';
        variant.options.slice(1).forEach((value,offset)=>{
          const position=offset+1,label=document.createElement('label');label.textContent=position===1?this.labels.size:this.labels.closure;
          const select=document.createElement('select');select.dataset.piece=index;select.dataset.pieceOption=position;select.setAttribute('aria-label',`${this.labels.piece} ${index+1}: ${label.textContent}`);
          [...new Set(this.variants.map(v=>v.options[position]))].forEach(optionValue=>{
            const options=[...variant.options];options[position]=optionValue;
            const option=document.createElement('option');option.value=optionValue;option.textContent=optionValue;option.selected=optionValue===value;option.disabled=!this.variants.some(v=>v.available&&v.options.every((o,i)=>o===options[i]));select.append(option);
          });label.append(select);row.append(label);
        });body.append(row);card.append(body);container.append(card);
      });
    }
    update() {
      const percent = this.count === 4 ? 25 : this.count === 2 ? 15 : 0;
      let subtotal = 0, total = 0;
      this.getItems().forEach(item => {
        const variant = this.variants.find(v => Number(v.id) === item.id);
        const line = (variant?.price || 0) * item.quantity;
        subtotal += line; total += Math.ceil((variant?.price || 0) * (100 - percent) / 100) * item.quantity;
      });
      this.querySelector('[data-bundle-total]').textContent = this.money.format(total / 100);
      const selectedPrices = this.ids.map(id => this.variants.find(variant => Number(variant.id) === Number(id))?.price || 0);
      const mixedPrices = new Set(selectedPrices).size > 1;
      const base = this.variants.find(v => Number(v.id) === this.variantId)?.price || 0;
      this.querySelectorAll('[data-bundle-card-total]').forEach(element => {
        const count = Number(element.dataset.bundleCardTotal);
        const rate = count === 4 ? .75 : count === 2 ? .85 : 1;
        const unitPrice = count === this.count ? total / this.count : Math.ceil(base * rate);
        element.textContent = this.money.format(unitPrice / 100);
        const before = this.querySelector(`[data-bundle-card-before="${count}"]`);
        if (before) before.textContent = this.money.format((count === this.count ? subtotal / this.count : base) / 100);
        this.querySelector(`[data-bundle-card-unit="${count}"]`).textContent = count === this.count && mixedPrices ? this.labels.averageLabel : this.labels.unitLabel;
      });
      const button = this.info?.querySelector('product-form button[type="submit"]');
      if (button && !button.disabled && button.getAttribute('aria-disabled') !== 'true') {
        const text = button.querySelector('span');
        if (text) text.textContent = this.labels.add.replace('[count]', this.count);
      }
      const quantity = this.info?.querySelector('.quantity__input');
      if (quantity) { quantity.value = this.count; quantity.dispatchEvent(new Event('change', {bubbles:true})); }
    }
  });
}
